import { ActionList, ActionMenu } from "@primer/react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { trangThaiHocSinhApi } from "../../api/trangThaiHocSinhApi";
import { useCommonContext } from "../../contexts/common";
import { RootState } from "../../state/reducers";
export type ComboboxTrangThaiHocSinhProps = {
    isReadonly?: boolean,
    value?: number,
    onValueChanged: (id: number) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined"
}
const ComboboxTrangThaiHocSinh = (props: ComboboxTrangThaiHocSinhProps) => {
    const { translate } = useCommonContext();
    const { language } = useSelector((x: RootState) => x.common)
    const [dm_TrangThaiHocSinhs, setDmTrangThaiHocSinhs] = useState<any[]>([]); 
    const selectedData = useMemo(() => {
        if (props.value && dm_TrangThaiHocSinhs) {
            return dm_TrangThaiHocSinhs.find(x => x.id == props.value)
        }
        return undefined
    }, [dm_TrangThaiHocSinhs, props.value])
    useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await trangThaiHocSinhApi.selectAllCheckDangKy(1);
				if (res.is_success) {
					setDmTrangThaiHocSinhs(res.data); 
				} else {
					console.error('Failed to load data:', res.message);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		fetchData();
	}, []);
    return (
        <div style={{ width: '100%' }}>
        <ActionMenu>
            <ActionMenu.Button
                aria-label="Chọn trạng thái"
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                {selectedData ? (language === "en" ? selectedData.trang_thai_en : selectedData.trang_thai) : translate("Chọn trạng thái")}
            </ActionMenu.Button>
            <ActionMenu.Overlay width="small">
                <ActionList selectionVariant="single">
                    {props.isShowClearButton &&
                        <ActionList.Item key={0} selected={props.value != undefined && 0 === props.value}
                            onSelect={() => {
                                props.onValueChanged(0)
                            }}
                        >
                            {language === "en" ? "Select" : "Chọn cấp học"}
                        </ActionList.Item>
                    }
                    {dm_TrangThaiHocSinhs && dm_TrangThaiHocSinhs.map((item, index) => {
                        return (
                            <ActionList.Item key={item.id} selected={props.value != undefined && item.id === props.value}
                                onSelect={() => {
                                    props.onValueChanged(item.id)
                                }}
                            >
                                {language === "en" ? item.trang_thai_en : item.trang_thai}
                            </ActionList.Item>
                        );
                    })}
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>
    </div>
    );
}

export { ComboboxTrangThaiHocSinh };

